<div class="filter-container" [class.compact]="data?.compact">
  <label class="filter-label">{{ formatLabel(data?.name) }}</label>
  <ng-select
    class="global-dropdown-select"
    [class.is-open]="isDropdownOpen"
    [items]="filteredOptions"
    [multiple]="data?.isMultiSelect"
    [closeOnSelect]="!data?.isMultiSelect"
    [(ngModel)]="selected"
    [searchable]="false"
    [clearable]="data?.clearable !== false && !data?.disabled"
    [disabled]="data?.disabled === true"
    [placeholder]="placeholderText"
    (change)="onChange()"
    (open)="onDropdownOpen()"
    (close)="onDropdownClose()"
  >
    <ng-template ng-header-tmp>
      <div class="custom-header">
        <div class="search-wrapper" *ngIf="showSearch">
          <input
            type="text"
            class="search-input"
            [placeholder]="searchPlaceholder"
            [formControl]="searchCtrl"
            (keydown)="$event.stopPropagation()"
          />
        </div>
        <div class="custom-option" *ngIf="showSelectAll">
          <input
            type="checkbox"
            id="select-all"
            [checked]="isAllSelected"
            (change)="toggleSelectAll($event)"
          />
          <label for="select-all">&nbsp;Select All</label>
        </div>
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index">
      <div class="option-row" [title]="formatOption(item)">
        <input
          *ngIf="data?.isMultiSelect"
          id="item-{{ index }}"
          type="checkbox"
          [checked]="isItemSelected(item)"
          [matTooltip]="formatOption(item)"
          matTooltipPosition="right"
        />
        <span>{{ formatOption(item) }}</span>
      </div>
    </ng-template>

    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      <div class="custom-multi-label-wrapper">
        <ng-container *ngIf="items?.length > 0">
          <div class="ng-value">
            <span class="ng-value-icon left" (click)="clear(items[0])">x</span>
            <span class="ng-value-label">{{ formatOption(items[0]) }}</span>
          </div>
        </ng-container>
        <span class="tag-summary" *ngIf="items?.length > 1">
          +{{ items.length - 1 }} more
        </span>
      </div>
    </ng-template>
  </ng-select>
</div>
